import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import noop from 'lodash/noop';

import {
  EmployeeCacheKeys,
  HourCacheKeys,
  TimeCardCacheKeys,
} from './cache-keys';

export const useInvalidatePunchCache = () => {
  const queryClient = useQueryClient();
  return useCallback(async () => {
    queryClient.invalidateQueries([HourCacheKeys.PBJ_HOURS]).catch(noop);
    queryClient.invalidateQueries([HourCacheKeys.DAILY_SUMMARY]).catch(noop);
    queryClient
      .invalidateQueries([HourCacheKeys.PAY_PERIOD_SUMMARY])
      .catch(noop);
    queryClient
      .invalidateQueries([TimeCardCacheKeys.PAY_PERIOD_APPROVAL])
      .catch(noop);
    queryClient
      .invalidateQueries([EmployeeCacheKeys.EMPLOYEE_UNDO_STACK])
      .catch(noop);
    await queryClient
      .invalidateQueries([TimeCardCacheKeys.EMPLOYEE_TIME_CARD])
      .catch(noop);
  }, [queryClient]);
};
